// Paddle.js configuration
// This file initializes Paddle for overlay checkout

declare global {
  interface Window {
    Paddle: any;
  }
}

// Initialize Paddle when the script loads
export const initPaddle = () => {
  if (typeof window === 'undefined' || !window.Paddle) {
    console.error('Paddle.js not loaded yet. Will retry...');
    return false;
  }

  try {
    // Hardcoded for now - we can move to env vars later if needed
    const environment = 'sandbox';
    const clientToken = 'test_63e2033147461853153786a5a44';

    // Set environment (sandbox or production)
    if (environment === 'sandbox') {
      window.Paddle.Environment.set('sandbox');
      console.log('🏖️ Paddle initialized in SANDBOX mode');
    } else {
      console.log('🚀 Paddle initialized in PRODUCTION mode');
    }

    // Initialize Paddle with client-side token
    window.Paddle.Initialize({
      token: clientToken,
      eventCallback: (event: any) => {
        console.log('🔔 Paddle event:', event.name);
        console.log('📦 Event data:', event.data);
        
        // Handle successful payment
        if (event.name === 'checkout.completed') {
          const transactionId = event.data?.transaction_id;
          console.log('✅ Payment completed! Transaction:', transactionId);
          
          // Show success message immediately
          alert('Payment successful! Your credits are being added...');
          
          // Give webhook time to process (4 seconds for sandbox), then do a full page reload
          // Full reload ensures credits are fetched fresh from the API
          setTimeout(() => {
            console.log('🔄 Reloading to fetch updated credits...');
            window.location.href = '/home?reload=' + Date.now(); // Force fresh load with cache bust
          }, 4000);
        }
        
        // Handle payment errors
        if (event.name === 'checkout.error') {
          console.error('❌ Checkout error:', event.data);
        }
        
        // Handle checkout closed without payment
        if (event.name === 'checkout.closed') {
          console.log('ℹ️ Checkout closed');
        }
      }
    });

    console.log('✅ Paddle initialized successfully!');
    return true;
  } catch (error) {
    console.error('❌ Failed to initialize Paddle:', error);
    return false;
  }
};

// Open Paddle checkout overlay
export const openPaddleCheckout = (priceId: string, customerEmail: string, customData: any) => {
  if (!window.Paddle) {
    console.error('Paddle not initialized');
    return;
  }

  window.Paddle.Checkout.open({
    items: [
      {
        priceId: priceId,
        quantity: 1,
      }
    ],
    customer: {
      email: customerEmail,
    },
    customData: customData,
  });
};

